import React from "react";
import * as sc from "./PrintChannelDataEditor.styled";

const PrintCampaignCreateChannelDataEditor = ({
  value,
  textStyle,
  label,
  ellipsis,
  urlValue,
  editable,
  withLabel,
  padding,
  dark,
  alias
}) => {
  return (
    <sc.ChannelDataEditorWrapper dark={dark}>
      <sc.ChannelDataWrapper
        ellipsis={ellipsis}
        style={textStyle}
        editable={editable}
        dark={dark}
        padding={padding}
      >
        {withLabel && <div style={{ marginBottom: "4px" }}>{`${label}: `}</div>}
        {urlValue ? (
          <sc.ChannelDataLink target="_blank" href={urlValue}>
            {value}
          </sc.ChannelDataLink>
        ) : (
          alias || value || label
        )}
      </sc.ChannelDataWrapper>
    </sc.ChannelDataEditorWrapper>
  );
};

export default PrintCampaignCreateChannelDataEditor;
